import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
  inject,
  observer,
  setDocumentTitle,
  setUidToken,
  getlangV2,
  setlang,
  closeWebViewPage,
} from 'src/helper/devTools.js'
import { hiddenBackButton } from '../../../helper/webviewFun'
import http from 'src/helper/http'
import { history } from 'src/core/router'
//import { Swiper, SwiperSlide } from 'swiper/react'
//import 'swiper/swiper-bundle.min.css'
import Toast from '../../../component/Toast'
import {  getDeviceInfo } from 'src/helper/webviewFun'
import LoadingComp from '../../../component/LoadingComp'
import localstorage from 'src/helper/localstorage'
import Recharge from 'src/component/Recharges/index'
import Message from 'src/component/Message'
import config from 'src/core/config'
import hybridRouter from 'src/core/hybrid-router'
import { isRussiaHost } from 'src/helper/tool'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    uid: 0,
    personalInfo: {},
    toUserInfo: {},
    lang: langM.ar,
    tabState: 1,
    sendPopUpState: false,
    toUserId: '',
    toUserIdRuby: '',
    desc: '',
    userRuby: 0,
    freezeRuby: 0,
    priceList: [],
    priceIndex: 0,
    ruby: 1000,
    price: 100,
    goldList: [],
    goldIndex: 0,
    nowGold: 0,
    priceGold: 100,
    recordPopUpState: false,
    goldRecordList: [],
    rubyRecordList: [],
    goldMore: false,
    rubyMore: false,
    goldScroll: '',
    rubyScroll: '',
    isLoading: false,
    goldConf: true,
    dollar: 0,
    isAgent: false,
    language: 'en',
    seachUserKw: '',
    seachUserInfoValue: {},
    inCbCf:false,
    showTabSelect:false
  }

  async componentWillMount() {
    // 跳转到新界面
    window.location.href = isRussiaHost() ? config.hostHybridRu : config.hostHybrid + hybridRouter.agentCoin

    let { language } = this.props.location.query
    setDocumentTitle('AgentRecharge')
    language = await getlangV2(language, langM)
    try {
      hiddenBackButton('0')
    } catch (error) {
      
    }
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    if (!uid) {
      this.props.location.query = localstorage.get('userInfo')
      uid = localstorage.get('userInfo').uid
    }
    this.setState({
      uid: uid
    })
    this.RunOnStart(uid)
  }

  getDdispatchList = async () => {
    let res = await http.post('/web/product/dispatch/list');
    if (res.code == 0) {
      this.setState({
        goldList: res.res.gold,
        priceList: res.res.ruby,
      })
      this.onSelectPriceGold(0, res.res.gold[0].price, res.res.gold[0].gold)
    }
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    let personalInfo = await this.ruby.GetUserInfoWeb(uid)
    let paypalType = localstorage.get('paypalType')
    this.setState({ personalInfo: personalInfo })
    let noapp = true
    if (paypalType && paypalType == 1) {
      try {
        let res  = await getDeviceInfo()
      } catch (error) {
         noapp = false
         console.log('不是app')
      }
      this.setState({ goldConf: false, tabState: 1,inCbCf:noapp?true:false})
    } else if (paypalType && paypalType == 2) {
      try {
        let res  = await getDeviceInfo()
      } catch (error) {
         noapp = false
         console.log('不是app')
      }
      this.setState({ goldConf: false, tabState: 2,inCbCf:noapp?true:false })
    }
    if (personalInfo.agentRechargeDisplay == 1) {
      this.setState({showTabSelect:true}) 
    }
  }

  // 改变 Tab
  onChangeTab(state) {
    let { priceIndex, priceList } = this.state
    if (state == 2 && priceIndex == 0) {
      this.onSelectPrice(0, priceList[0].price, priceList[0].gold)
    }
    this.setState({
      tabState: state,
    })
  }

  // 红宝石选择
  onSelectPrice(index, price, ruby) {
    this.setState({
      priceIndex: index,
      ruby,
      price
    })
  }
  // 金币选择
  onSelectPriceGold(index, priceGold, nowGold) {
    this.setState({
      goldIndex: index,
      nowGold,
      priceGold
    })
  }
  //loginout
  loginout = () => {
    localstorage.remove('userInfo')
    history.replace(`/app/agentlogin`)
  }
  // 获取金币信息宝石
  updateGoldRuby = async () => {
    let personalInfo = await this.ruby.GetUserInfoWeb(this.state.uid)
    this.setState({
      personalInfo: personalInfo
    })
    
  }
  // 提交金币、红宝石
  async onHandleAssign() {
    let { nowGold, priceGold, toUserId, lang, seachUserInfoValue } = this.state
    try {
      this.setState({
        isLoading: true
      })
      if (nowGold > 9999999) {
        this.setState({
          desc: lang.sendPl
        })
        this.refs.toast.hideRule(true)
        return
      }
      //  金币
        let res = await this.ruby.goldAgentRecharge(toUserId || seachUserInfoValue.duid, parseInt(priceGold), parseInt(nowGold))
        if (res.code != 0) {
          this.setState({
            sendPopUpState: false,
            desc: res && res.msg
          })
          if (res.code == 78) {
            this.setState({
              desc: this.state.lang.noyourcontuer
            })
          }
          this.refs.toast.hideRule(true)
          return
        }
      this.setState({
        desc: this.state.lang.transfer_toast4,
        sendPopUpState: false,
        isLoading: false,
        seachUserInfoValue:{},
        seachUserKw:'',
      })
      document.querySelector('.inInput').value = ''
      this.refs.toast.hideRule(true)
      this.updateGoldRuby()
    } catch (error) {
    } finally {
      this.setState({
        isLoading: false
      })
    }

  }

  // 输入用户id
  onHandleInput(e, state) {
    if (state == 1) {
      this.setState({
        toUserId: e.currentTarget.value
      })
    } else if (state == 2) {
      this.setState({
        toUserIdRuby: e.currentTarget.value
      })
    }
  }

  // 查询用户展示
  async onHandleBtn(state) {
    let { nowGold, lang } = this.state
    if (nowGold < 1) {
      this.setState({
        desc: lang.totalTips
      })
      this.refs.toast.hideRule(true)
      return
    }
    try {
      this.setState({
        isLoading: true
      })
      let toUserId = 0
      if (state == 1) {
        // 金币
        toUserId = this.state.toUserId
      } else if (state == 2) {
        // 红宝石
        toUserId = this.state.toUserIdRuby
      }
      if (toUserId == '') {
        this.setState({
          desc: this.state.lang.noUid
        })
        this.refs.toast.hideRule(true)
        return
      }
      let res = await this.ruby.searchUserInfo(toUserId) // 查询用户接口
      if (res.code != 0 || !toUserId) {
        // 失败提醒
        this.setState({
          desc: res && res.msg
        })

        this.refs.toast.hideRule(true)
        return
      }
      if (res && res.res == null) {
        this.setState({
          desc: this.state.lang.noSearch
        })
        this.refs.toast.hideRule(true)
        return
      }
      // 成功
      this.setState({
        toUserInfo: res && res.res, // 用户信息
        sendPopUpState: true // 打开弹窗
      })
    } catch (error) {
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  async onHandleRecord() {
    this.setState({
      isLoading: true,
      goldRecordList: null,
      goldMore: null,
      goldScroll: null,
      rubyRecordList: null,
      rubyMore: null,
      rubyScroll: null
    })
    if (this.state.tabState == 1) {
      return history.push(`app/goldRecold?type=1`)
    }
    this.setState({
      recordPopUpState: true
    })
    document.querySelector('.record-wrap-scroll').scroll(0, 0)
    document.querySelector('.record-wrap-scroll').scrollTop = 0
    this.setState({
      isLoading: false
    })
  }

  contentComp(open, close, lang) {
    return (
      <div
        className="question-content"
        onClick={() => {
          close()
        }}
      >
        {lang.noNation}
      </div>
    )
  }
  //金币充值交互弹窗
  showGoldModle = (open, close, lang) => {
    let { priceGold, nowGold } = this.state
    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">Check your bill</div>
        <div className="gold-modle-body">
          <div className="amount">
            <div className="amout-left">Recharge Amount</div>
            <div className="amout-rigit">{priceGold / 100}</div>
          </div>
          <div className="amount">
            <div className="amout-left">Get Coins</div>
            <div className="amout-rigit">{nowGold}</div>
          </div>
          <div className="amount">
            <div className="amout-left">Deduct Amount</div>
            <div className="amout-rigit">{priceGold / 100}</div>
          </div>
        </div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            Cancel
          </div>
          <div
            className="modle-confirm"
            onClick={() => {
              this.onHandleBtn(1)
            }}
          >
            Confirm
          </div>
        </div>
      </div>
    )
  }
  // 选择金币充值给谁
  handSect = async () => {
    let { goldConf } = this.state
    await this.setState({ goldConf: !goldConf })
  }

  payYour = (lang) => {
    return (
      <div className="btn-root">
        <div className="appropriate-btn" >{lang.recharge}</div>
      </div>
    )
  }

  sendGoldFn = async (e) => {
    let { nowGold } = this.state
    if (e.target.value.length > 7) {
      document.querySelector('.new-send-input').value = e.target.value.slice(0, 7)
    } else {
      await this.setState({ nowGold: e.target.value })
    }
  }
  seachUserInfo = (e) => {
    if (e.target.value.length > 10) {
      document.querySelector('.inInput').value = e.target.value.slice(0, 10)
    } else {
      this.setState({ seachUserKw: e.target.value })
    }

  }
  handleClose = () => {
    try {
      closeWebViewPage()
    } catch (error) {
      history.replace('/app/agentlogin')
    }
    //
  }


  getSeachInfo = async () => {
    let { seachUserKw, personalInfo, lang } = this.state
    let d = await http.post('/web/user/info', { uidDuid: seachUserKw })
    this.timeId = setTimeout(()=>{this.inTimeTrue = false},1000)
    this.setState({ desc: lang.noSearch })
    if (d.code != 0) return this.refs.toast.hideRule(true)
    this.setState({ desc: lang.search_for_user_toast2 })
    if (d.code == 0 && !d.res)  return  this.refs.toast.hideRule(true)
      this.setState({ desc: lang.transfer_toast2 })
    if (personalInfo.region != d.res.region)  return  this.refs.toast.hideRule(true)
    this.setState({  seachUserInfoValue: d.res })
  }
  inTimeTrue = false
  timeId = null
  handleSeachInfo = async()=>{
    let { seachUserKw, lang } = this.state
    if (seachUserKw.trim().length == 0) {
      this.setState({ desc: lang.accountId })
       return  this.refs.toast.hideRule(true)
    } 
    if (!this.inTimeTrue) {
      this.inTimeTrue = true
      this.getSeachInfo()
    }
  }
  getGoldStr = () => {
    let { personalInfo } = this.state
    let num =  personalInfo.agentGold || 0
    if (num == 0) return num
    let str = ''
    str = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return str || 0
  }

  handleDisc = () => {
    let { lang, nowGold } = this.state
    this.setState({ desc: lang.totalTips })
    if (nowGold<1) return this.refs.toast.hideRule(true)
    this.setState({ sendPopUpState: true })
  }

  numberThumbnail = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  render() {
    let { showTabSelect, seachUserInfoValue, inCbCf, nowGold,  personalInfo, goldConf, lang, uid, language, isAgent } = this.state
    return (
      <div
        className={`gold-agent-new ${this.state.language == 'ar' && 'arlang'}`}
      >
        <Toast ref="toast" toastContent={this.state.desc} />
        <LoadingComp show={this.state.isLoading} />
        <div className='ruby-agent-nav'>
          <div style={{height:'0.88rem',width:'6rem'}}></div>
        <div className='close-web-view'>
          <img className='close-img-icon' style={{ transform: `rotate(${language == 'ar' ? '180' : '0'}deg)` }} onClick={() => this.handleClose()} src='/img/app/ruby-agent/close-icon.png' />
          <div className='name-text'>{lang.coin_transfer}</div>
          <img className='close-img-icon' onClick={() => history.push(`app/newGoldRecold?inCbCf=${inCbCf?1:3}`)} src='/img/app/ruby-agent/recolde-detail.png' />
        </div>
        </div>
        <div style={{height:'1.76rem',width:'7.5rem'}}></div>
        <div className='otp' style={{height:`0.08rem`,width:'7.5rem'}}> </div>
        <div className='tiew-tiitle'>
        <div className='rirt-lise'></div>
        <div className='gold-bg-new'>
          <div className='text-tips'>{lang.available_coins}</div>
          <div className='gold-icon-num'>
            <img className='gold-icon-img' src='/img/app/ruby-agent/big-gold-icon.png'></img>
            <div className='text-num'>{this.getGoldStr()}</div>
          </div>
        </div>
        {showTabSelect && <div className='tab-changes'>
          <div className={`distrible ${goldConf ? "in-select-ino" : ""}`} onClick={() => this.handSect()}>{lang.distribute}</div>
          <div className={`recharge  ${!goldConf ? "in-select-ino" : ""}`} onClick={() => this.handSect()}>{lang.recharge}</div>
        </div>}
        {goldConf && <div>
          <div className='tips-black'>{lang.input_user_id_tips1}</div>
          <div className='in-the-input-root'>
            <div className={'input-root'}>
              <img className='seach-icon' src='/img/app/ruby-agent/seach_icon.png' />
              <input className='inInput' placeholder={lang.search_for_user_toast1} onChange={e => this.seachUserInfo(e)} />
            </div>
            <div className={'seach-btn'} onClick={() => this.handleSeachInfo()}>{lang.search}</div>
          </div>
          {seachUserInfoValue.uid && <div className='seach-info'>
            <img className='seach-atv' src={seachUserInfoValue.avatarurl} />
            <div className='info-detail'>
              <div className='name'>{seachUserInfoValue.nickname}</div>
              <div className='id-num'>ID: {seachUserInfoValue.duid}</div>
            </div>
          </div>}
          {seachUserInfoValue.uid && (<div>
            <div className='dist-tips'>{lang.input_transfer_coins_tips1}</div>
            <div className='send-gold-root'>
              <input className='new-send-input' maxLength={7} type='number' onChange={e => this.sendGoldFn(e)} placeholder={lang.sendPl} ></input>
            </div>
            <div className='send-btn' onClick={() => this.handleDisc()} style={{ opacity: `${nowGold.length > 0 ? '1' : '0.4'}` }}>{lang.recharge}</div>
          </div>)}
        </div>}
        {!goldConf && <div>
          <div className={`content`}>
            {true && goldConf && <div className='rechage-input-value'>
              <div className='inamount'>{lang.Amount}</div>
              <div className='input-root'>
                <img className='gold-icon' src='/img/app/newhost/glod_icon.png'></img>
                <input className='send-inpe' maxLength='7' type='number' onChange={e => this.sendGoldFn(e)} placeholder={lang.sendPl}></input>
              </div>
            </div>}
            {false && this.state.goldList &&
              goldConf &&
              this.state.goldList.map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      this.onSelectPriceGold(index, item.price, item.gold)
                    }}
                    className={`content-item ${this.state.goldIndex == index ? 'content-item-active' : ''}`}
                    key={index}
                  >
                    <div>
                      <span className="num">{item.gold}</span>
                      {/* <br /> */}
                      {/* <span className="gold">{item.price / 100}</span> */}
                    </div>
                  </div>
                )
              })}
            {this.state.tabState == 1 && !goldConf && <Recharge location={this.props} id={uid} usconfs={this.payYour} updagold={() => { this.updateGoldRuby }} lang={lang} type={'gold'} degold={personalInfo.overdrawGold} addNum={personalInfo.agentGold || 0}></Recharge>}
          </div>
        </div>}
        </div>
        <div className="send-popup" style={{ display: `${this.state.sendPopUpState ? 'block' : 'none'}` }}>
          <div className="shadow"></div>
          <div className="content">
            <div className="top">
              <div className="title">{lang.tips}</div>
              <div className="info">
               {language !='ar' && language!='tr' && <div> Confirm to transfer <span>{this.numberThumbnail(nowGold)}</span> coins to ID:<span>{seachUserInfoValue.duid}</span></div>}
               {language=='tr' && <div><span >{this.numberThumbnail(nowGold)}</span> ID'ye Altın Aktarılmasını Onaylayın:<span>{seachUserInfoValue.duid}</span></div>}
               { language=='ar' && <div>تأكيد توزيع <span >{ this.numberThumbnail(nowGold)}</span> كونزات إلى المعرف:<span>{seachUserInfoValue.duid}</span></div>}
              </div>
            </div>
            <div className="bottom">

              <div
                className="cancle"
                onClick={() => {
                  this.setState({ sendPopUpState: false })
                }}
              >
                {this.state.lang.no}
              </div>
              <div
                className="confirm"
                onClick={() => {
                  this.onHandleAssign()
                }}
              >
                {this.state.lang.yes}
              </div>
            </div>
          </div>
        </div>
        <Message ref="msg" desc={this.state.desc} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-agent/index.js